import {prop} from "../../decorators/property";

export class UserHistoryItemModel extends Backbone.AssociatedModel {

    @prop() public Type: number;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/user-history/models/user-history-item.ts